import { Component, inject, input, output, signal } from '@angular/core';
import { User } from '../../../model/user.model';
import { EditSysadminComponent } from '../edit-sysadmin/edit-sysadmin.component';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SysAdminService } from '../../../services/sys-admin.service';
import { ConfirmBoxComponent } from '../../../components/confirm-box/confirm-box.component';
import { ModalConfigsHelper } from '../../../helpers/modal-configs.helper';
import { smallModalConfig, wideModalConfig } from '../../../consts/modal-config.const';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { StatusChipComponent } from '../../../components/status-chip/status-chip.component';

@Component({
  selector: 'app-administrators-section',
  templateUrl: './administrators-section.component.html',
  styleUrls: ['./administrators-section.component.scss'],
  imports: [
    MatButton,
    MatDivider,
    MatIconButton,
    MatIcon,
    MatCard,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    StatusChipComponent
  ]
})
export class AdministratorsSectionComponent {
  sysadminList = input.required<User[]>();
  updateSysadminList = output<void>();

  administratorsExpanded = signal<boolean>(false);

  #dialog = inject(MatDialog);
  #messagingService = inject(MessagingService);
  #modalConfigsHelper = inject(ModalConfigsHelper);
  #sysAdminService = inject(SysAdminService);

  addSysAdmin(user?: User) {
    const dialogConfig: MatDialogConfig = wideModalConfig;
    dialogConfig.data = user || null;
    this.#dialog
      .open(EditSysadminComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.#messagingService.confirm(result === 'created' ? 'New Admin Invited' : 'Admin saved');
          this.updateSysadminList.emit();
        }
      });
  }

  enableDisableSysAdmin(user: User, enable: boolean) {
    const request = enable
      ? this.#sysAdminService.enableUser(user.username)
      : this.#sysAdminService.disableUser(user.username);

    request.subscribe(() => this.updateSysadminList.emit());
  }

  confirmArchiveSysAdmin(username: string): void {
    const data = { title: 'Archive User', alertMessage: 'User will be archived.', confirmButton: 'ARCHIVE' };
    this.#dialog
      .open(ConfirmBoxComponent, this.#modalConfigsHelper.buildMediumModalConfig(data, smallModalConfig))
      .afterClosed()
      .subscribe((result) => result === 'ARCHIVE' && this.#archiveSysAdmin(username));
  }

  confirmDeleteInvitedSysAdmin(username: string): void {
    const data = {
      title: 'Delete Invited User',
      alertMessage: 'Invited user will be deleted.',
      confirmButton: 'DELETE'
    };
    this.#dialog
      .open(ConfirmBoxComponent, this.#modalConfigsHelper.buildMediumModalConfig(data, smallModalConfig))
      .afterClosed()
      .subscribe((result) => result === 'DELETE' && this.#deleteInvitedSysAdmin(username));
  }

  #archiveSysAdmin(username: string): void {
    this.#sysAdminService.archiveSysadmin(username).subscribe({
      complete: () => this.updateSysadminList.emit()
    });
  }

  #deleteInvitedSysAdmin(username: string): void {
    this.#sysAdminService.deleteSysadminOrMlAdmin(username).subscribe({
      complete: () => this.updateSysadminList.emit()
    });
  }
}
